export default __webpack_public_path__ + "static/media/plusIcon.f91d78b4.svg";